module.exports = __webpack_public_path__ + "static/media/ic-arrow-up.37d06b44.svg";